document.addEventListener("DOMContentLoaded", function() {
    var heroContent = document.getElementById("hero-content");
    var heroImage = document.getElementById("hero-image");

    function checkHeroLoaded() {
        if (document.readyState === "complete" && heroImage.complete) {
            heroContent.style.opacity = "1";
        } else {
            setTimeout(checkHeroLoaded, 50);
        }
    }

    checkHeroLoaded();
});